module.exports = __webpack_public_path__ + "static/media/Bre Arder.9eacf83e.png";